module.exports = __webpack_public_path__ + "img/astral_4.36d94c87.svg";